import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {BigWinLevel, RoadKillWinConfigs} from "../RoadKillWinConfigs";
import {BasicBitmapCountUp} from "../component/BasicBitmapCountUp";
import {RoadKillGameAssets} from "../RoadKillGameAssets";
import {RoadKill} from "../RoadKill";
import {gsap,Back, Power1, Power3, TimelineLite} from "gsap";
import {RoadKillSound} from "../sound/RoadKillSound";
import {SimplePresentationRunnerController} from "../../core/winpresentation/SimplePresentationRunner";
import {RoadKillGameConfig} from "../RoadKillGameConfig";
import {RoadKillGameMode} from "../server/RoadKillGameMode";
import {BelowStakeWinRestriction} from "../server/BelowStakeWinRestriction";
import {IBetWinData, IWinHighLightData, RoadKillGameData} from "../server/RoadKillData";
import {RoadKillSymbol} from "../reels/RoadKillSymbol";
import {RoadKillUtils} from "../utils/RoadKillUtils";
import {RoadKillSymbolStates} from "../component/enums/RoadKillEnums";
import {RoadKillModel} from "../server/RoadKillModel";
import {RoadKillIndividualSymWinView} from "./RoadKillIndividualSymWinView";


export class RoadKillBigWinView extends PIXI.Container implements StageLayer {
    private _individualSymWinWaysCont: PIXI.Container;
    private _countUp: BasicBitmapCountUp;
    private _bigWinSpine: PIXI.spine.Spine;
    private _waysCount: PIXI.Text;
    private _bounceDuration: number = 0.25;

    constructor() {
        super();
        this.name = "bigWinView";
        this.init();
    }

    public onResize() {

    }
    public resetIndividualSymWinViewCont():void{
        this._individualSymWinWaysCont.removeChildren();
    }

    public playBigWin(flowStateController: SimplePresentationRunnerController, calledFromWinCap: boolean = false): TimelineLite {
        const tl: TimelineLite = new TimelineLite({
                onComplete: () => {
                    if (!RoadKill.model.brokeTheBank) {
                        flowStateController.finish();
                    }
                    this._countUp.position.y = 313;
                    this._waysCount.position.y = 440;
                }
            }),
            winRatio: number = calledFromWinCap ? (RoadKill.model.winRatio <= 15 ? 212 : RoadKill.model.winRatio) : RoadKill.model.winRatio,
            levels: BigWinLevel[] = RoadKillWinConfigs.getBigWinLevels(winRatio),
            gameData: RoadKillGameData = RoadKill.model.gameData;

        let levelAborted: boolean = false;
        const totalWinWays: number = this.getTotalWays();
        this._waysCount.text = totalWinWays > 1 ? totalWinWays.toString().concat(" " + RoadKill.apiPlugin.translations.translate("Ways Won")) : totalWinWays.toString().concat(" " + RoadKill.apiPlugin.translations.translate("Way Won"));
        tl.add(this.winPositions());
        tl.add(() => {
            RoadKillUtils.shake(1.1, RoadKill.model.gameData.betWayWins.length === 3 ? 60 : 50);
        }, "-=0.6");
        for (let i: number = 0; i < levels.length; i++) {
            const level: BigWinLevel = levels[i],
                isLastLevel: boolean = i === levels.length - 1;
            tl.add(() => {
                levelAborted = false;
            });
            tl.add(() => {
                flowStateController.setSkipCallback(() => {
                    levelAborted = true;
                    tl.seek(level.name + "_end", false);
                })
            })
            tl.add(RoadKill.bigWinView.getLevelAnimation(level.from * RoadKill.model.gameData.playedBetValue, isLastLevel ? RoadKill.model.gameData.totalSpinWinnings : level.to * RoadKill.model.gameData.playedBetValue, level.duration, level.id, isLastLevel));
            tl.addLabel(level.name + "_end");
            tl.add(() => flowStateController.setSkipCallback());
            tl.add(() => {
                if (levelAborted) {
                    RoadKill.soundPlayer.stopTrack(RoadKillSound.BIG_WIN_LEVEL[level.id - 1]);
                }
            })
        }

        tl.add(() => {
            this._countUp.stopAt(gameData.totalSpinWinnings);
            !RoadKill.model.gameData.brokeTheBank && RoadKill.keypadPlugin.setWin(RoadKill.model.accumulatedRoundWin, this.isTotalWin(), BelowStakeWinRestriction.isWinBelowStake());
        });
        if (!RoadKill.model.gameData.brokeTheBank) {
            tl.add(RoadKill.bigWinView.showEnd());
        }
        if (RoadKill.model.gameData.totalAnimalHitsSFS === 20 || RoadKill.model.nextMode === RoadKillGameMode.RESPIN) {
            tl.add(this.hideCountUp());
        }
        if (RoadKill.model.brokeTheBank) {
            tl.to(this, {duration: 0.1});
        }
        if (RoadKill.model.specialSymLandingArray.length || RoadKill.model.brokeTheBank) {
            tl.add(RoadKill.winToggle.preWinToggle());
        }
        return tl;
    }

    public hideCountUp(): TimelineLite {
        const tl: TimelineLite = new TimelineLite({
                onComplete: () => {
                    this._countUp.visible = false;
                    this._bigWinSpine.visible = false;
                    this._waysCount.visible = false;
                }
            }
        );
        tl.to([this._countUp, this._bigWinSpine, this._waysCount], {
            duration: RoadKillGameConfig.HIDE_AND_ALPHA_DURATION,
            alpha: 0
        });
        tl.add(this.resetSpineAnimation());
        return tl;
    }

    public getCountUpScaleAnimation(duration: number, ease: string, to: number, from?: number): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        if (from != undefined) {
            tl.add(() => {
                this._countUp.scale.set(from, from)
            });
        }
        tl.to(this._countUp.scale, {duration: duration, x: to, y: to, ease: ease});
        return tl;
    }

    public onReelStart(): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        tl.add(this.hideCountUp());
        return tl;
    }

    public moveToReset(durr: number): TimelineLite {
        const movementTL: TimelineLite = new TimelineLite();

        movementTL.to(this._countUp.scale, {x: 1, y: 1, duration: durr}, 0)
        return movementTL.to(this._countUp, {y: 313, duration: durr, ease: Power3.easeOut}, 0);
    }

    protected winPositions(): TimelineLite {
        const gameData: RoadKillModel = RoadKill.model,
            animationDurr: number = 0.5,
            noWinAlpha: number = 0.45,
            tl: TimelineLite = new TimelineLite(),
            winGrps: IWinHighLightData[] = gameData.normalWinDataHighlight,
            allWinSymbols: boolean[][] = RoadKill.model.allWinPositions;
        let playWildCircleOnlyOnce: boolean = true;

        let startPos: number = 0;

        if (winGrps.length > 1) {
            for (let groups: number = 0; groups < winGrps.length; groups++) {
                const winData: IWinHighLightData = winGrps[groups],
                    symPosForWinWays:[number,number]=[0,0];
                for (let reel = 0; reel < winData.reelWinPositions.length; reel++) {
                    let posRow: boolean[] = winData.reelWinPositions[reel];
                    for (let row = 0; row < posRow.length; row++) {
                        const sym: RoadKillSymbol | undefined = RoadKillUtils.getSymbol(reel, row);
                        if(posRow[row]){
                            symPosForWinWays[0]=reel;
                            symPosForWinWays[1]=row;
                        }                        if (sym) {
                            tl.add(() => sym.markNonWin(!posRow[row], noWinAlpha, animationDurr / 2), startPos);
                            tl.add(() => {
                                sym.glowPreHit(posRow[row], animationDurr, winData.winLvl)
                            }, startPos);
                        }
                    }
                }
                const winWaysPos:PIXI.Point=RoadKillUtils.getSymbol(symPosForWinWays[0], symPosForWinWays[1]).position,
                    winWaysObj:RoadKillIndividualSymWinView=new RoadKillIndividualSymWinView(winData.multipliedAmount,winData.numberOfCombinations,new PIXI.Point(winWaysPos.x,winWaysPos.y+RoadKillGameConfig.SYMBOL_HEIGHT+30));
                this._individualSymWinWaysCont.addChild(winWaysObj);
                tl.add(()=>{
                    winWaysObj.showWinAndWays(0.5);
                });
                tl.add(() => {
                    RoadKill.soundPlayer.playTrack(RoadKillSound.WIN_SYM_HIGHLLIGHT[groups]);
                }, startPos);
                startPos += animationDurr / 1.75;
            }

            for (let reel = 0; reel < allWinSymbols.length; reel++) {
                let posRow: boolean[] = allWinSymbols[reel];
                for (let row = 0; row < posRow.length; row++) {
                    const sym: RoadKillSymbol | undefined = RoadKillUtils.getSymbol(reel, row);
                    if (sym) {
                        tl.add(() => sym.markNonWin(!posRow[row], noWinAlpha, animationDurr / 3), startPos);
                        tl.add(() => {
                            sym.glowPreHit(posRow[row], animationDurr, 4)
                        }, startPos);
                    }
                }
            }
            tl.add(() => {
                RoadKill.soundPlayer.playTrack(RoadKillSound.WIN_SYM_HIGHLLIGHT[winGrps.length - 1]);
            }, startPos);
            startPos += animationDurr / 1.75;
        }
        for (let reel = 0; reel < allWinSymbols.length; reel++) {
            let posRow: boolean[] = allWinSymbols[reel];
            for (let row = 0; row < posRow.length; row++) {
                const sym: RoadKillSymbol | undefined = RoadKillUtils.getSymbol(reel, row);
                if (sym) {
                    if (posRow[row]) {
                        tl.add(() => {
                            this.playWinAnimation(reel, row);
                        }, startPos);
                    } else {
                        if (winGrps.length === 1) {
                            tl.add(() => sym.markNonWin(true, noWinAlpha, animationDurr / 3), startPos);
                        }
                    }
                }
                if (playWildCircleOnlyOnce && gameData.evaluatedArea[reel][row] === "W") {
                    tl.add(() => {
                        RoadKill.soundPlayer.playTrack(RoadKillSound.WILD_CIRCLE);
                    }, startPos)
                    playWildCircleOnlyOnce = false;
                }
            }
        }
        if(RoadKill.model.normalWinDataHighlight.length===1){
            tl.add(this.winWaysForOneSymWin(),0);
        }
        tl.add(() => {
            if (RoadKill.backgroundElements.getMultiplierValue() >= 2 && RoadKill.model.mode !== RoadKillGameMode.NORMAL) {
                RoadKill.backgroundElements.playMultiplierAnim().timeScale(2);
            }
            RoadKill.soundPlayer.playTrack(RoadKillSound.WIN_SYM_HIGHLLIGHT[3]);
        }, startPos);

        tl.to(this, {duration: animationDurr});
        return tl;
    }

    private winWaysForOneSymWin():gsap.core.Timeline{
        const tl:gsap.core.Timeline=gsap.timeline();
        if(RoadKill.model.normalWinDataHighlight.length===1){
            const winData:IWinHighLightData=RoadKill.model.normalWinDataHighlight[0],
                symPosForWinWays:[number,number]=[0,0];
            for (let reel = 0; reel < winData.reelWinPositions.length; reel++) {
                let posRow: boolean[] = winData.reelWinPositions[reel];
                for (let row = 0; row < posRow.length; row++) {
                    if(posRow[row]){
                        symPosForWinWays[0]=reel;
                        symPosForWinWays[1]=row;
                    }
                }
            }
            const winWaysPos:PIXI.Point=RoadKillUtils.getSymbol(symPosForWinWays[0], symPosForWinWays[1]).position,
                winWaysObj:RoadKillIndividualSymWinView=new RoadKillIndividualSymWinView(winData.multipliedAmount,winData.numberOfCombinations,new PIXI.Point(winWaysPos.x,winWaysPos.y+RoadKillGameConfig.SYMBOL_HEIGHT+30));
            this._individualSymWinWaysCont.addChild(winWaysObj);
            tl.add(()=>{
                winWaysObj.showWinAndWays(0.6);
            });
        }
        return tl;
    }

    private playWinAnimation(reelId: number, symId: number): TimelineLite {
        const symbol: RoadKillSymbol = RoadKillUtils.getSymbol(reelId, symId);
        const tl: TimelineLite = new TimelineLite();
        if (RoadKill.model.data.evaluatedArea[reelId][symId] === "W") {
            tl.add(symbol.playWildOverlayWinAnimation(), 0);
        } else {
            tl.add(symbol.setState(RoadKillSymbolStates.WIN, "", 0, true), 0);
        }
        tl.to(this, {duration: 0.3});
        return tl;
    }

    private showEnd(): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        tl.add(() => {
            if (RoadKill.model.mode === RoadKillGameMode.RESPIN) {
                RoadKill.soundPlayer.fadeTrack(RoadKillSound.RESPIN_BG_MUSIC, 400, 1);
            }
            RoadKill.soundPlayer.playTrack(RoadKillSound.BIG_WIN_END);
            RoadKill.soundPlayer.fadeMusic(1, 400);
            RoadKill.particleManager.bigWinParticles.enableEmit(false);
            RoadKill.particleManager.bigWinParticles2.enableEmit(false);
            RoadKill.particleManager.bigWinParticles3.enableEmit(false);
        });
        tl.add(() => {
            this._countUp.bounceHit(6, this._bounceDuration);
        });
        tl.to(this, {duration: this._bounceDuration});
        tl.to(this._bigWinSpine, {alpha: 0, duration: 0.8});
        tl.add(this.moveToReset(0.8), "<");
        tl.add(this.showWinWaysText());
        tl.to(this, {duration: 0.5});
        return tl;
    }

    private showWinWaysText(durr: number = 0.2): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        this._waysCount.alpha = 0
        this._waysCount.visible = true;
        tl.to(this._waysCount, {alpha: 1, duration: durr});
        return tl;
    }

    private isTotalWin(): boolean {
        return !(RoadKill.model.mode === RoadKillGameMode.NORMAL && RoadKill.model.nextMode === RoadKillGameMode.NORMAL);
    }

    private getLevelAnimation(countFrom: number, countTo: number, duration: number, level: number, isLastLevel: boolean): TimelineLite {
        const tl: TimelineLite = new TimelineLite({
            onStart: () => {
                this._bigWinSpine.visible = true;
                this._countUp.visible = true;
                this._bigWinSpine.alpha = 1;
                if (level === 1) {
                    this._bigWinSpine.alpha = 0;
                    this._countUp.alpha = 0;
                } else {
                    this._bigWinSpine.alpha = 1;
                    this._countUp.alpha = 1;
                    RoadKill.soundPlayer.playTrack(RoadKillSound.BIG_WIN_LEVEL_CHANGE);
                }
            }
        });
        if (level === 1) {
            tl.add(() => {
                this.moveDown(false, 0.5);
            }, 0);
            tl.to(this._countUp, {alpha: 1, duration: 0.9, ease: Power1.easeOut}, 0);
        }
        tl.add(() => {
            this._countUp.bounceHit(8, this._bounceDuration);
            if (level === 2) {
                RoadKill.particleManager.bigWinParticles.enableEmit(true);
            } else if (level === 3) {
                RoadKill.particleManager.bigWinParticles2.enableEmit(true);
            } else if (level === 4) {
                RoadKill.particleManager.bigWinParticles3.enableEmit(true);
            }
        }, level === 1 ? 0.5 : 0);

        if (level === 1) {
            tl.to(this._bigWinSpine, {alpha: 1, duration: 0.2}, 0.5);
            tl.add(() => {
                if (RoadKill.model.gameData.mode === RoadKillGameMode.RESPIN) {
                    RoadKill.soundPlayer.fadeTrack(RoadKillSound.RESPIN_BG_MUSIC, 400, 0);
                }
                RoadKill.soundPlayer.fadeMusic(0, 500);
                RoadKill.soundPlayer.playTrack(RoadKillSound.BIG_WIN_LEVEL_CHANGE);
            }, 0.5)
        }


        tl.add(() => {
            this._bigWinSpine.updateTransform();
            this._bigWinSpine.state.clearTracks();
            this._bigWinSpine.skeleton.setSlotsToSetupPose();
            this._bigWinSpine.skeleton.setToSetupPose();
            this._bigWinSpine.updateTransform();
            this._bigWinSpine.state.addAnimation(0, `Big_Win_${level}_Intro`, false, 0);
            if (level > 0) {
                RoadKill.soundPlayer.stopTrack(RoadKillSound.BIG_WIN_LEVEL[level - 2]);
            }
            RoadKill.soundPlayer.playTrack(RoadKillSound.BIG_WIN_LEVEL[level - 1]);
        }, level === 1 ? 0.5 : 0)

        tl.add(() => {
            this._bigWinSpine.state.addAnimation(0, `Big_Win_${level}`, true, 0);
        }, this._bigWinSpine.skeleton.data.findAnimation(`Big_Win_${level}_Intro`).duration);

        tl.add(this._countUp.getCountAnimation(countFrom, countTo, duration), 0);
        const scale: TimelineLite = new TimelineLite();
        scale.add(this.getCountUpScaleAnimation(0.1, "power2.in", 1.2));
        scale.add(this.getCountUpScaleAnimation(0.2, "power2.out", 1.0));
        scale.add(this.getCountUpScaleAnimation(tl.duration() - 0.3, "power2.in", 0.8));
        tl.add(scale, 0);
        return tl;
    }

    private init(): void {
        this._countUp = this.createCountUp();
        this._bigWinSpine = this.createbigWinSpine();
        this._waysCount = this.createWaysCount();
        this._individualSymWinWaysCont = new PIXI.Container();
        this.onResize();
        this.addChild(this._bigWinSpine, this._individualSymWinWaysCont,RoadKill.particleManager, this._countUp, this._waysCount);
    }

    private createWaysCount(): PIXI.Text {
        const pixiText: PIXI.Text = new PIXI.Text("", new PIXI.TextStyle(RoadKillGameConfig.WAYS_STYLE));
        pixiText.alpha = 0;
        pixiText.visible = false;
        pixiText.anchor.set(0.5, 0.5);
        pixiText.position.set(360, 440);
        return pixiText;
    }

    private getTotalWays(): number {
        const betWaysWin: IBetWinData[] = RoadKill.model.betWayWins;
        let totalWays: number = 0
        betWaysWin.forEach((individualBetWin) => {
            totalWays += individualBetWin.numberOfCombinations;
        });
        return totalWays;
    }

    private createbigWinSpine(): PIXI.spine.Spine {
        const spine: PIXI.spine.Spine = new PIXI.spine.Spine(RoadKill.assetLoader.getSpineAsset("bigWin"));
        spine.position.set(360, 360);
        spine.visible = false;
        return spine;
    }

    private resetSpineAnimation(): TimelineLite {
        return new TimelineLite().add(() => {
            this._bigWinSpine.state.setEmptyAnimation(0, 0);
            this._bigWinSpine.state.clearTracks();
        })
    }

    private moveDown(scaling: boolean = true, duration: number = 0.5): gsap.core.Timeline {
        const movementTL: TimelineLite = new TimelineLite();

        if (scaling) movementTL.to(this._countUp.scale, {x: "-=" + 0.27, y: "-=" + 0.27, duration: duration})
        return movementTL.to(this._countUp.position, {y: "+=" + 252, duration: duration, ease: Back.easeIn});
    }

    private createCountUp(): BasicBitmapCountUp {
        const countUp: BasicBitmapCountUp = new BasicBitmapCountUp({
            fontName: RoadKillGameAssets.BITMAP_FONT_WIN_COUNT_UP,
            fontSize: 130,
            tint: 0xffffff
        }, 720);
        countUp.alpha = 0;
        countUp.position.set(360, 313);
        countUp.pivot.set(0);
        countUp.visible = false;
        return countUp;
    }
}